/**
 *    @author:
 *    @since:
 *
 */

import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { InputData,Eligibility, AboutChild } from '../../_common/data/input-data';
import { ItemList } from '../../_common/constant/item-list';
import { Util } from '../../../refresh/service/Util';
import { BirthdayValidation } from './birth-day.validator';
import { ViewportScroller } from '@angular/common';

@Component({ 
      selector: 'birth-day',
      templateUrl: './birth-day.component.html',
      styleUrls: ['./birth-day.component.less']
})
export class BirthdayComponent {

       public eligibility:Eligibility;
       public error_birthDay:string;

       birthdayValidation:BirthdayValidation;

       @Input ('ng-model')  input:string;
       @Output('ng-modelChange')  inputChange = new EventEmitter<any>();

       @Input('nextRegistration') nextRegis: string = "N";

       constructor( public items:ItemList,
                    public data:InputData,
                    public viewportScroller: ViewportScroller,
                    private elRef:ElementRef ) {

              this.eligibility = data.eligibility;
              this.birthdayValidation = new BirthdayValidation(this);
       }

       public birthdayUpdatedEvent() {
              this.inputChange.emit(this.input);
              let ret = Util.isEligible(this.input);
              this.eligibility.isOneYearMore = ( ret == Util.ONE_YEAR_MORE );
 
       }

       public validate() :boolean {
              return this.birthdayValidation.validate();
       }
}